import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Grid,
  List,
  ListItem,
  Tooltip,
  Divider,
} from "@material-ui/core";
import CheckCircleSharpIcon from '@material-ui/icons/CheckCircleSharp';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    position: "relative",
    overflow: "auto",
    height: 300,
    marginTop: "16px",
  },
}));

const ScenarioNamesListing = ({ list, tagName, uuid, closeDailog }) => {
  const classes = useStyles();
  return (
    <div style={{ height: "445px" }}>
      <div>Number of selected scenarios: <b>{list.length}</b></div>
      <div>
        CAD uuid: <b>{uuid}</b>
      </div>
      <div>
        Tag name: <b>{tagName}</b>
      </div>
      <Divider style={{ marginTop: "5px" }} />
      <Grid container spacing={3}>
        <List className={classes.root}>
          {list.map((item) => (
            <ListItem key={`item-${item.name}`}>
              <div
                style={{display: 'flex'}}>
                <span>{item.name}</span>
                <span>{item.input_scenario_mapping ?
                  <CheckCircleSharpIcon style={{marginLeft: '1rem', color: "#b0ff45"}}/> :
                  <Tooltip placement="top" title={<h6>Input scenario not mapped</h6>}>
                    <WarningIcon style={{marginLeft: '1rem', color: "#ffcc00"}}/>
                  </Tooltip>}
                </span>
              </div>
            </ListItem>
          ))}
        </List>
        <Grid item sm={12} sx={{ mt: -2 }}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              onClick={() => closeDailog(false)}
              variant="outlined"
              style={{ marginRight: "1rem" }}
            >
              Close
            </Button>
          </Box>
        </Grid>
        {/* <Grid item sm={6}>
        </Grid> */}
      </Grid>
    </div>
  );
};
export default ScenarioNamesListing;
